// src/admin/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FaSpinner } from "react-icons/fa";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--text-2)",
          gap: "0.75rem",
          fontFamily: "var(--font-display)",
        }}
      >
        <FaSpinner
          className="spin"
          size={20}
          style={{ animation: "spin 0.8s linear infinite" }}
        />
        Loading…
      </div>
    );
  }

  // Remember where we were headed (incl. ?tab=… and a bookmarklet #import=…)
  // so signing in lands back there instead of on the default tab.
  return user ? children : <Navigate to="/admin" replace state={{ from: location }} />;
};

export default ProtectedRoute;
